import {defineSlotRecipe} from '@chakra-ui/react3'

const displayPriceRecipe = defineSlotRecipe({
    slots: [
        'container',
        'priceOrder',
        'originalPrice',
        'priceContainer',
        'price',
        'freeLabel',
        'discountLabel',
        'taxesLabel'
    ],
    base: {
        container: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column',
            justifyContent: 'flex-start'
        },
        priceOrder: {
            alignItems: 'center',
            flexDirection: 'row-reverse',
            flexWrap: 'wrap',
            gap: 'spacing-4'
        },
        originalPrice: {
            backgroundColor: 'background.actions.ghost',
            borderRadius: 'xs',
            paddingInline: 'spacing-4',
            color: 'text.secondary',
            textDecoration: 'line-through',
            textStyle: 'body.small'
        },
        priceContainer: {
            color: 'text.secondary',
            textStyle: 'heading.xlarge'
        },
        price: {},
        freeLabel: {},
        discountLabel: {
            display: 'none'
        },
        taxesLabel: {
            display: 'none',
            color: 'text.tertiary',
            textStyle: 'body.xsmall'
        }
    },
    variants: {
        variant: {
            productTile: {
                priceContainer: {
                    textStyle: 'heading.medium'
                }
            },

            xpdp: {
                priceOrder: {
                    justifyContent: 'center'
                },
                price: {
                    lineHeight: '1'
                },
                taxesLabel: {
                    display: 'block'
                }
            },

            'xpdp-configurator': {
                priceOrder: {
                    justifyContent: 'center'
                },
                taxesLabel: {
                    display: 'block'
                }
            },
            'xpdp-configuration-item': {
                container: {
                    alignItems: 'center',
                    flexDirection: 'row'
                },
                priceContainer: {
                    color: 'text.primary',
                    textStyle: 'heading.medium'
                }
            },
            'xpdp-quickview': {
                priceOrder: {
                    gap: 'spacing-8'
                },

                taxesLabel: {
                    display: 'block'
                }
            },
            'xpdp-engraving': {
                container: {
                    gap: 'spacing-4'
                },
                priceContainer: {
                    textStyle: 'heading.medium'
                }
            },
            'xpdp-configurator-summary': {
                container: {
                    justifyContent: 'space-between'
                },
                priceOrder: {
                    justifyContent: 'flex-start'
                },
                priceContainer: {
                    textStyle: 'heading.medium'
                }
            },
            'xpdp-configurator-summary-footer': {
                container: {
                    alignSelf: 'center',
                    width: 'fit-content'
                },

                taxesLabel: {
                    display: 'block',
                    alignSelf: 'flex-start'
                }
            },
            'sticky-bar': {
                taxesLabel: {
                    display: 'block',
                    alignSelf: 'flex-start'
                },
                priceOrder: {
                    justifyContent: 'flex-end'
                },
                priceContainer: {
                    flexShrink: 1,
                    textStyle: 'heading.medium'
                }
            }
        },
        alignment: {
            start: {
                container: {
                    alignItems: 'flex-start'
                }
            },
            center: {
                container: {
                    alignItems: 'center'
                }
            },
            end: {
                container: {
                    alignItems: 'flex-end'
                }
            }
        }
    }
})

export default displayPriceRecipe
